// extracted by mini-css-extract-plugin
module.exports = {"overlayWrapper":"overlay_overlayWrapper__Wlipe"};